module.exports = __webpack_public_path__ + "img/printing.509d8851.svg";